import { cva } from '@/styled-system/css';

export const popoverBackdropRecipe = cva({
  variants: {
    modal: {
      true: {
        display: 'grid',
        placeItems: 'center',
        zIndex: 'popover',
        blockSize: 'auto',
        maxBlockSize: 'none',
        inlineSize: 'auto',
        maxInlineSize: 'none',
        paddingBlock: 'layout.looser',
        paddingInline: 'layout.tight',
        transitionProperty: {
          _motionReduce: 'none',
          _motionSafe: 'opacity',
        },
        transitionDuration: {
          _motionReduce: '0s',
          _motionSafe: '{durations.200}',
        },
        transitionTimingFunction: '{easings.ease-out}',

        _before: {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'bg.screen.scrim',
          opacity: 'dialogScrim',
          zIndex: 1,
          isolation: 'isolate',
        },
      },
      false: {},
    },
    open: {
      true: {
        opacity: 1,
      },
      false: {
        opacity: 0,
      },
    },
  },
});
